// extracted by mini-css-extract-plugin
export var alternate = "_o-j";
export var black = "_o-6";
export var blue = "_o-f";
export var blueLight = "_o-e";
export var brand = "_o-8";
export var darkMode = "_o-b";
export var error = "_o-a";
export var gray = "_o-5";
export var grayBlue = "_o-d";
export var iconWrapper = "_o-3";
export var inactive = "_o-7";
export var indigo = "_o-g";
export var orange = "_o-i";
export var pink = "_o-h";
export var primary = "_o-0";
export var purple = "_o-9";
export var success = "_o-4";
export var warning = "_o-c";
export var white = "_o-1";
export var whiteSuccess = "_o-2";